var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInspectionLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12_1883)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 15.9512C14.3301 17.4248 12.2712 18.3333 9.99996 18.3333C5.39758 18.3333 1.66663 14.6023 1.66663 10C1.66663 5.39763 5.39758 1.66667 9.99996 1.66667C12.3311 1.66667 14.4387 2.62387 15.9511 4.16667",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66663 12.5C7.42673 13.512 8.63688 14.1667 9.99996 14.1667C10.5925 14.1667 11.1562 14.0429 11.6666 13.8199",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.6741 7.5H6.66663",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3334 10.8333C14.7141 10.8333 15.8334 9.71404 15.8334 8.33333C15.8334 6.95262 14.7141 5.83333 13.3334 5.83333C11.9527 5.83333 10.8334 6.95262 10.8334 8.33333C10.8334 9.71404 11.9527 10.8333 13.3334 10.8333Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3334 10C18.1606 9.67008 18.0742 9.50516 17.96 9.36066C17.668 8.99116 17.232 8.70058 16.7132 8.5295C16.5104 8.46258 16.2847 8.4195 15.8334 8.33333",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12_1883"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInspectionLight);
export default __webpack_public_path__ + "static/media/inspection_light.e16b1e0c9c329e2b00f5b25d33f38580.svg";
export { ForwardRef as ReactComponent };